<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="Addendum"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] BA Addendum {{ typeName }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION && header.Status != this.$APPROVAL_STATUS.FULL_APPROVAL)"/>
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('doc_date')" fieldName="Doc_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="doc_date" v-model="header.Doc_Date" type="text"
                                :placeholder="$t('doc_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Doc_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('doc_date')) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t('company_contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <CustomSelect name="Contractor_Code" :filter="true"  v-if="header"
                                    v-model="header.Contractor_Code" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/contractor_code'"
                                    :minLength="0"
                                     :params="{ docDate: (this.header.Doc_Date != null ? this.header.Doc_Date  : null)}" 
                                    :disabled="true"
                                    />
                                    <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                </small>
                            </FormField>

                           <FormField :labelName="$t('job_desc')" fieldName="Deskripsi_Pekerjaan" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea name="Deskripsi_Pekerjaan" v-model="header.Deskripsi_Pekerjaan" required="true" type="text"
                                    :placeholder="$t('job_desc')" v-if="header" @change="onChange()"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            <FormField :labelName="$t('no_spk')" fieldName="No_SPK" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPK" v-model="header.No_SPK" required="true" type="text"
                                    :placeholder="$t('no_spk')" v-if="header"
                                    :disabled="true" />
                            </FormField>
                            
                            <div class="field grid">
                                <label for="Persentase_Actual_Awal" class="col-4">{{ $t('initial_actual_percentage')}} (%)</label>
                                <div class="col-6 md-6">
                                    <InputNumber name="Initial_Actual_Percentage" v-model="header.Initial_Actual_Percentage" type="text" :placeholder="$t('initial_actual_percentage')"
                                        v-if="header"
                                        :disabled="header.Percentage_Type != 'Cut Off'|| (mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT)" :useGrouping="false" :max="100"/>
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>

                            <FormField :labelName="$t('type_Persentase')" fieldName="Type_Persentase" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <div class="flex flex-wrap gap-3">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Percentage_Type" name="Type_Persentase" :value="'Penambahan'" v-if="header" @change="onChangeTypePersentase()" :disabled="(mode != $FORM_MODE_CREATE && mode != $FORM_MODE_EDIT) || (header.Amount < 0)"/>
                                        <label for="Type_Persentase" class="ml-2 mr-2">Penambahan</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Percentage_Type" name="Type_Persentase" :value="'Pengurangan'"  v-if="header" @change="onChangeTypePersentase()" :disabled="(mode != $FORM_MODE_CREATE && mode != $FORM_MODE_EDIT) || (header.Amount > 0)"/>
                                        <label for="Type_Persentase" class="ml-2">Pengurangan</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.Percentage_Type" name="Type_Persentase" :value="'Cut Off'"  v-if="header" @change="onChangeTypePersentase()" :disabled="(mode != $FORM_MODE_CREATE && mode != $FORM_MODE_EDIT) || (header.Amount > 0)"/>
                                        <label for="Type_Persentase" class="ml-2">Cut Off</label>
                                    </div>
                                </div>

                                    <small v-if="header && !header.Percentage_Type && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('type_Persentase')) }}
                                    </small>
                            </FormField>

                            <div class="field grid">
                                <label for="Deduction_Percentage" class="col-4">{{ $t('persentase_pp')}} (%)</label>
                                <div class="col-6 md-6">
                                    <InputNumber name="Deduction_Percentage" v-model="header.Deduction_Percentage" type="text" :placeholder="$t('persentase_pp')"
                                        v-if="header" mode="decimal" :maxFractionDigits="2"
                                        :disabled="true" :useGrouping="false" v-lock-input="true"/>
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                            <FormField :labelName="$t('persentase_cut_off')" fieldName="Cut_Off_Progress" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Cut_Off_Progress" v-model="header.Cut_Off_Progress" type="text" :placeholder="$t('persentase_cut_off')"
                                    v-if="header" :disabled="true"  v-lock-input="true"
                                    :useGrouping="false" :max="100"  v-tooltip.bottom="$t('messagebox.cutoff')" :maxFractionDigits="2"/>
                            </FormField>
                        </div>
                        <div class="col-6">
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('initial_value_contract')" fieldName="Initial_Contract_Amount" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Initial_Contract_Amount" v-model="header.Initial_Contract_Amount" required="true" type="text" :useGrouping="true" :minFractionDigits="0" :maxFractionDigits="2"
                                    :placeholder="$t('initial_value_contract')" v-if="header"
                                    :disabled="true" v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Initial_Contract_Amount }"/>
                                    <small v-if="header && !header.Initial_Contract_Amount && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('initial_value_contract')) }}
                                    </small>
                            </FormField>
                            <FormField :labelName="$t('nilai_pp')" fieldName="Amount" v-model="header" labelClass="col-4" fieldClass="col-6">                                  
                                    <InputNumber name="Amount" v-model="this.header.Amount" required="true" type="text"  :useGrouping="true" :minFractionDigits="0" :maxFractionDigits="2"
                                        :placeholder="$t('nilai_pp')" v-if="header"
                                         :disabled="true" 
                                         v-lock-input="true"
                                         :inputClass="{ 'bg-yellow': header.isNotMatch_Amount }"/>
                                    <small v-if="header && this.header.Amount == null && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('nilai_pp')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('final_value_contract')" fieldName="Actual_Contract_Amount" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Actual_Contract_Amount" v-model="header.Actual_Contract_Amount" required="true" type="text"
                                    :placeholder="$t('final_value_contract')" v-if="header"  :useGrouping="true" :minFractionDigits="0" :maxFractionDigits="2"
                                    :disabled="true"
                                    v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Actual_Contract_Amount }"/>
                                    <small v-if="header && !header.Actual_Contract_Amount && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('final_value_contract')) }}
                                    </small>
                            </FormField>
                            <FormField :labelName="$t('Final_Contract_Amount')" fieldName="Final_Contract_Amount" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Final_Contract_Amount" v-model="header.Final_Contract_Amount" required="true" type="text"
                                    :placeholder="$t('Final_Contract_Amount')" v-if="header"  :useGrouping="true" :minFractionDigits="0" :maxFractionDigits="2" @change="onChangeNewSPO()" @input="onChangeNewSPO"
                                   
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                    <small v-if="header && !header.Final_Contract_Amount && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Final_Contract_Amount')) }}
                                    </small>
                            </FormField>
                            <FormField :labelName="$t('New_SPO')" fieldName="New_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <div class="flex flex-wrap gap-3">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.New_SPO" name="New_SPO" :value="true" v-if="header" :disabled="isSPODisabled" @change="onChangeNewSPO()"/>
                                        <label for="New_SPO" class="ml-2 mr-2">Yes</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.New_SPO" name="New_SPO" :value="false"  v-if="header" :disabled="isSPODisabled" @change="onChangeNewSPO()"/>
                                        <label for="New_SPO" class="ml-2">No</label>
                                    </div>
                                </div>

                                    <small v-if="header && header.New_SPO == null && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('New_SPO')) }}
                                    </small>
                            </FormField>
                            <FormField v-if="header && header.New_SPO == false" fieldName="SPO_Category_Type" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <div class="flex flex-wrap gap-3">
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.SPO_Category_Type" name="SPO_Category_Type" :value="'Add Line'" v-if="header" :disabled="isSPOCategoryDisabled"/>
                                        <label for="SPO_Category_Type" class="ml-2 mr-2">Add Line</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <RadioButton v-model="header.SPO_Category_Type" name="SPO_Category_Type" :value="'Edit Initial Line'"  v-if="header" :disabled="isSPOCategoryDisabled"/>
                                        <label for="SPO_Category_Type" class="ml-2">Edit Initial Line</label>
                                    </div>
                                </div>

                                    <small v-if="header && !header.SPO_Category_Type && submitted && mode != this.$FORM_MODE_DELETE && header.New_SPO == false"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('SPO_Category_Type')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('Contract_Amount_Initial_SPO')" fieldName="Contract_Amount_Initial_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Contract_Amount_Initial_SPO" v-model="header.Contract_Amount_Initial_SPO" required="true" type="text"
                                    :placeholder="$t('Contract_Amount_Initial_SPO')" v-if="header"  :useGrouping="true" :minFractionDigits="0" :maxFractionDigits="2"
                                    :disabled="true" 
                                    v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Contract_Amount_Initial_SPO }"/>
                            </FormField>
                            <FormField :labelName="$t('Contract_Amount_New_SPO')" fieldName="Contract_Amount_New_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputNumber name="Contract_Amount_New_SPO" v-model="header.Contract_Amount_New_SPO" required="true" type="text"
                                    :placeholder="$t('Contract_Amount_New_SPO')" v-if="header"  :useGrouping="true" :minFractionDigits="0" :maxFractionDigits="2"
                                    :disabled="true" 
                                    v-lock-input="true"
                                    :inputClass="{ 'bg-yellow': header.isNotMatch_Contract_Amount_New_SPO }"/>
                            </FormField>
                            <FormField :labelName="$t(labelAppr1)" fieldName="Username_Appr1" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr1">
                                <CustomSelect name="Username_Appr1" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr1" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As1, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.ADDENDUM, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr1 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr1)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr2)" fieldName="Username_Appr2" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr2">
                                <CustomSelect name="Username_Appr2" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr2" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As2, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.ADDENDUM, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr2  && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr2)) }}
                                </small>
                            </FormField>
                            <FormField :labelName="$t(labelAppr3)" fieldName="Username_Appr3" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr3">
                                <CustomSelect name="Username_Appr3" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr3" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion:header.Appr_As3, doc_type : this.$TypeDocument.ADDENDUM, contractorcode : header.Contractor_Code,companycode: header.Company_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr3 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr3)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t(labelAppr4)" fieldName="Username_Appr4" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="labelAppr4">
                                <CustomSelect name="Username_Appr4" :filter="true"  v-if="header"
                                    v-model="header.Username_Appr4" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"
                                    :params="{job_postion : header.Appr_As4, user_type:this.$UserType.WILMAR, doc_type : this.$TypeDocument.ADDENDUM, companycode: header.Company_Code, contractorcode : header.Contractor_Code }" 
                                    :disabled="true"/>
                                    <small v-if="header && !header.Username_Appr4 && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelAppr4)) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.FULL_APPROVAL"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>
                        </div>
                            <div class="col-6">
                                <DataTable v-if="header" :loading="!header" :value="header.reasons ? header.reasons : null"
                                    responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                    <Column :exportable="false" style="width:30px">
                                        <template #header>
                                            <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                                @click="addDetailReason()"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                @click="deleteDetailReason(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </template>
                                    </Column>
                                    <Column field="Reason" :header="$t('reason')" Key="Id">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                    :placeholder="$t('reason')" @change="onCellEditCompleteReason(slotProps)"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                                    <br/>
                                                <small
                                                    v-if="header && !slotProps.data.Reason && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                                </small>
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                            <div class="col-6">
                                <DataTable v-if="header" :loading="!header" :value="header.summaryScope ? header.summaryScope : null"
                                    responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                    <Column :exportable="false" style="width:30px">
                                        <template #header>
                                            <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                                @click="addDetailScope()"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                                @click="deleteDetailScope(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </template>
                                    </Column>
                                    <Column field="Scope" :header="$t('scope')" Key="Id">
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <Textarea 
                                                    v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                    :placeholder="$t('scope')" @change="onCellEditCompleteScope(slotProps)"
                                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                    v-show="slotProps.data.mode != 'Delete'" />
                                                    <br/>
                                                <small
                                                    v-if="header && !slotProps.data.Scope && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('scope')) }}
                                                </small>
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>

                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>
<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "AddendumMCIndex",
            url: this.$API_URL + "AddendumMC/GetDataAddendum/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            type: "",
            typeName: "",
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            reason : null,
            scope : null,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            labelAppr1 : "",
            labelAppr2 : "",
            labelAppr3 : "",
            labelAppr4 : "",
            submitted2 : false,
            onlyDraft: false,

        }
    },
    methods: {
        onChangeTypePersentase(e){            
            if(this.header.Percentage_Type == "Penambahan"){
                //this.header.Actual_Contract_Amount = this.header.Initial_Contract_Amount + this.header.Amount;
                this.header.Initial_Actual_Percentage = this.header.Current_MC;
            }
            else if(this.header.Percentage_Type == "Pengurangan") {
               // this.header.Actual_Contract_Amount = this.header.Initial_Contract_Amount + this.header.Amount;
                this.header.Initial_Actual_Percentage = this.header.Current_MC;
            }
            else if(this.header.Percentage_Type == "Cut Off"){
                //this.header.Actual_Contract_Amount = this.header.Initial_Contract_Amount + this.header.Amount;
            }

            if(this.header.Percentage_Type == "Cut Off")
            {     
                this.header.Deduction_Percentage = null;
                this.header.Cut_Off_Progress = this.header.DeviationTemp;
            }else{
                this.header.Cut_Off_Progress = null;
                this.header.Deduction_Percentage = this.header.DeviationTemp;
            }
        },
        onChangeNewSPO(e)
        {
            if(this.header.New_SPO)
            {
                this.header.Contract_Amount_Initial_SPO = this.header.Initial_Contract_Amount + this.header.total_Amount_Scope_Deviasi;
                if (e === null || e === undefined)
                {
                    this.header.Contract_Amount_New_SPO = this.header.Final_Contract_Amount - this.header.Contract_Amount_Initial_SPO;
                }else{
                    const value = e?.value ?? 0;
                    this.header.Contract_Amount_New_SPO = value  - this.header.Contract_Amount_Initial_SPO;
                }

            }
            else
            {
                if (e === null || e === undefined)
                {
                    this.header.Contract_Amount_Initial_SPO = this.header.Final_Contract_Amount;
                }else{
                    const value = e?.value ?? 0;
                    this.header.Contract_Amount_Initial_SPO = value;
                }
                this.header.Contract_Amount_New_SPO = null;

            }
        },
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },
        getData() {
            var self = this;
              this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode + "/" + this.type)
                .then((response) => {
                    
                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = self.header.request_log;
                    self.dataModelRelease = self.header.approval_log;
                    self.detailLog = self.header.DetailLog;
                    self.reason = self.header.reasons;
                    self.scope = self.header.summaryScope;
                    self.dataModelChild = self.header.listChild;
                    var listAppr = response.data.data.listPicAppr;
                    
                    if(listAppr.length > 0)
                    {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.header.Appr_As1 = a.Approval_As;
                                self.header.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.header.Appr_As2 = a.Approval_As;
                                self.header.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.header.Appr_As3 = a.Approval_As;
                                self.header.Sign_Position3 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 4){
                                self.labelAppr4 = a.Approval_As;
                                self.header.Appr_As4 = a.Approval_As;
                                self.header.Sign_Position4 =  a.Sign_Position;
                            }
                        });
                    }
                    // Auto set New_SPO = false and SPO_Category_Type = 'Edit Initial Line' when Amount <= 0 (only for Create and Edit mode)
                    if(self.header.Amount <= 0 && (self.mode === self.$FORM_MODE_CREATE || self.mode === self.$FORM_MODE_EDIT)) {
                        self.header.New_SPO = false;
                        self.header.SPO_Category_Type = 'Edit Initial Line';
                    }
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            var data = new FormData();
            var h = this.header;

            // Scalar fields
            data.append("Id", h.Id);
            data.append("mode", h.mode);
            if (h.Main_Data_Id != null) data.append("Main_Data_Id", h.Main_Data_Id);
            if (h.Doc_RKTK_Id != null) data.append("Doc_RKTK_Id", h.Doc_RKTK_Id);
            if (h.Type != null) data.append("Type", h.Type);
            data.append("Doc_Date_String", moment(h.Doc_Date).format('YYYY/MM/DD').toString());
            if (h.Doc_No != null) data.append("Doc_No", h.Doc_No);
            if (h.No_SPO != null) data.append("No_SPO", h.No_SPO);
            if (h.No_SPK != null) data.append("No_SPK", h.No_SPK);
            if (h.Budget != null) data.append("Budget", h.Budget);
            if (h.No_WO != null) data.append("No_WO", h.No_WO);
            if (h.Deskripsi_Pekerjaan != null) data.append("Deskripsi_Pekerjaan", h.Deskripsi_Pekerjaan);
            if (h.Contractor_Code != null) data.append("Contractor_Code", h.Contractor_Code);
            if (h.Company_Code != null) data.append("Company_Code", h.Company_Code);
            if (h.Initial_Actual_Percentage != null) data.append("Initial_Actual_Percentage", h.Initial_Actual_Percentage);
            if (h.Percentage_Type != null) data.append("Percentage_Type", h.Percentage_Type);
            if (h.Deduction_Percentage != null) data.append("Deduction_Percentage", h.Deduction_Percentage);
            if (h.Cut_Off_Progress != null) data.append("Cut_Off_Progress", h.Cut_Off_Progress);
            if (h.Initial_Contract_Amount != null) data.append("Initial_Contract_Amount", h.Initial_Contract_Amount);
            if (h.Amount != null) data.append("Amount", h.Amount);
            if (h.Actual_Contract_Amount != null) data.append("Actual_Contract_Amount", h.Actual_Contract_Amount);
            if (h.Final_Contract_Amount != null) data.append("Final_Contract_Amount", h.Final_Contract_Amount);
            if (h.DeviationTemp != null) data.append("DeviationTemp", h.DeviationTemp);
            if (h.New_SPO != null) data.append("New_SPO", h.New_SPO);
            if (h.Contract_Amount_Initial_SPO != null) data.append("Contract_Amount_Initial_SPO", h.Contract_Amount_Initial_SPO);
            if (h.Contract_Amount_New_SPO != null) data.append("Contract_Amount_New_SPO", h.Contract_Amount_New_SPO);
            if (h.total_Amount_Scope_Deviasi != null) data.append("total_Amount_Scope_Deviasi", h.total_Amount_Scope_Deviasi);
            if (h.Status != null) data.append("Status", h.Status);
            if (h.Username_Appr1 != null) data.append("Username_Appr1", h.Username_Appr1);
            if (h.Username_Appr2 != null) data.append("Username_Appr2", h.Username_Appr2);
            if (h.Username_Appr3 != null) data.append("Username_Appr3", h.Username_Appr3);
            if (h.Username_Appr4 != null) data.append("Username_Appr4", h.Username_Appr4);
            if (h.Reason != null) data.append("Reason", h.Reason);
            if (h.SPO_Category_Type != null) data.append("SPO_Category_Type", h.SPO_Category_Type);
            if (h.Wo_Number_Main != null) data.append("Wo_Number_Main", h.Wo_Number_Main);

            // Approver sign fields (from BaseModel)
            if (h.Appr_As1 != null) data.append("Appr_As1", h.Appr_As1);
            if (h.Appr_As2 != null) data.append("Appr_As2", h.Appr_As2);
            if (h.Appr_As3 != null) data.append("Appr_As3", h.Appr_As3);
            if (h.Appr_As4 != null) data.append("Appr_As4", h.Appr_As4);
            if (h.Sign_Position1 != null) data.append("Sign_Position1", h.Sign_Position1);
            if (h.Sign_Position2 != null) data.append("Sign_Position2", h.Sign_Position2);
            if (h.Sign_Position3 != null) data.append("Sign_Position3", h.Sign_Position3);
            if (h.Sign_Position4 != null) data.append("Sign_Position4", h.Sign_Position4);

            // reasons array
            if (h.reasons != null) {
                for (var i = 0; i < h.reasons.length; i++) {
                    var reason = h.reasons[i];
                    if (reason.mode != null) data.append(`reasons[${i}].mode`, reason.mode);
                    if (reason.Id != null) data.append(`reasons[${i}].Id`, reason.Id);
                    if (reason.Doc_MC_Addendum_Id != null) data.append(`reasons[${i}].Doc_MC_Addendum_Id`, reason.Doc_MC_Addendum_Id);
                    if (reason.Reason != null) data.append(`reasons[${i}].Reason`, reason.Reason);
                }
            }

            // summaryScope array
            if (h.summaryScope != null) {
                for (var j = 0; j < h.summaryScope.length; j++) {
                    var scope = h.summaryScope[j];
                    if (scope.mode != null) data.append(`summaryScope[${j}].mode`, scope.mode);
                    if (scope.Id != null) data.append(`summaryScope[${j}].Id`, scope.Id);
                    if (scope.Doc_MC_Addendum_Id != null) data.append(`summaryScope[${j}].Doc_MC_Addendum_Id`, scope.Doc_MC_Addendum_Id);
                    if (scope.Scope != null) data.append(`summaryScope[${j}].Scope`, scope.Scope);
                }
            }

            this.$axios.post(this.$API_URL + "AddendumMC/SaveAddendum/", data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "MC Addendum has been deleted successfully", life: 3000 }, query: { activeIndex: 2 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "MC Addendum has been saved successfully", life: 3000 }, query: { activeIndex: 2 } });
                        }
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        formatErrorMessage(message) {
            const MAX_ERROR_LENGTH = 1000;

            let detail = '';

            if (typeof message === 'string') {
                detail = message;
            } else if (message && typeof message === 'object') {
                if (typeof message.response?.data?.message === 'string') {
                    detail = message.response.data.message;
                } else if (typeof message.message === 'string') {
                    detail = message.message;
                } else if (Array.isArray(message)) {
                    detail = message
                        .map(item => (typeof item === 'string' ? item : (item && item.message) ? item.message : ''))
                        .filter(Boolean)
                        .join('\n');
                }
            } else if (message != null) {
                detail = String(message);
            }

            if (!detail) {
                detail = 'An unexpected error occurred';
            }

            if (detail.length > MAX_ERROR_LENGTH) {
                detail = detail.slice(0, MAX_ERROR_LENGTH) + '...';
            }

            return detail;
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: this.formatErrorMessage(message), life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/AddendumMC/Index", query: { activeIndex: 2 } });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            this.submitted2 = true;
            var self = this;
            
            if(this.header.summaryScope.length == 0){
                self.showError("Error", "Must have one summary scope")
                return;
            }

            if(this.header.Actual_Contract_Amount < 0){
                self.showError("Error", "Cannot Submit, Final Contract Value cannot be Minus")
                return;
            }
            if(this.header.Final_Contract_Amount > this.header.Actual_Contract_Amount){
                self.showError("Error", "Cannot Submit, Final Contract Amount must be equals or less than Actual Contract Amount (Rounding)")
                return;
            }
            if(this.header.New_SPO === true && (this.header.Contract_Amount_New_SPO === null || this.header.Contract_Amount_New_SPO <= 0)){
                self.showError("Error", "Cannot Submit, Contract Amount for New SPO cannot be 0 or minus")
                return;
            }
            if(((self.header.Status == this.$APPROVAL_STATUS.FULL_APPROVAL  || self.header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL) &&  !this.header.Reason)
                || (this.labelAppr1 && !this.header.Username_Appr1) || (this.labelAppr2 && !this.header.Username_Appr2) || (this.labelAppr3 && !this.header.Username_Appr3) || (this.labelAppr4 && !this.header.Username_Appr4) 
                || (!self.header.Final_Contract_Amount) || (this.header.New_SPO == null) || (this.header.New_SPO == false && !this.header.SPO_Category_Type)
                )
            {
                return false;
            }
           
            var Reasons = this.header.reasons.filter(a=> a.mode != this.$FORM_MODE_DELETE && a.Reason);

            if(Reasons.length == 0){
                self.showError("Error", "Must have one reason")
                return;
            }

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            this.submitted2 = false;
            var self = this;

            if(this.header.Nilai_Akhir_Kontrak < 0){
                self.showError("Error", "Cannot Submit, Final Contract Value cannot be Minus")
                return;
            }
            if(this.header.Final_Contract_Amount > this.header.Actual_Contract_Amount){
                self.showError("Error", "Cannot Submit, Final Contract Amount must be equals or less than Actual Contract Amount (Rounding)")
                return;
            }
            if(this.header.New_SPO === true && (this.header.Contract_Amount_New_SPO === null || this.header.Contract_Amount_New_SPO <= 0)){
                self.showError("Error", "Cannot Submit, Contract Amount for New SPO cannot be 0 or minus")
                return;
            }
            if(this.header.summaryScope.length == 0){
                self.showError("Error", "Must have one summary scope")
                return;
            }
            if (!this.header.Doc_Date ) {
                return;
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetailScope() {
            var newDetail = this.scope;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.summaryScope.push(det);
        },
        deleteDetailScope(event) {
            if (event) {
                var detail = this.header.summaryScope[event.index];
                if (detail.mode == this.$FORM_MODE_CREATE) this.header.summaryScope.splice(this.header.summaryScope.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteScope(event) {
            this.editDetailScope(event.index);
        },
        editDetailScope(index) {
            if (this.header && this.header.summaryScope) {
                let mode = this.header.summaryScope[index].mode;
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.summaryScope[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },

        addDetailReason() {
            var newDetail = this.reason;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.reasons.push(det);
        },
        deleteDetailReason(event) {
            if (event) {
                var detail = this.header.reasons[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.reasons.splice(this.header.reasons.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteReason(event) {
            this.editDetailReason(event.index);
        },
        editDetailReason(index) {
            if (this.header && this.header.reasons) {
                let mode = this.header.reasons[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.reasons[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
    },
    computed:{
        Nilai_PP(){
            var result = (this.header.Persentase_PP/ 100) * this.header.Nilai_Awal_Kontrak;
           
            if(this.header.Type_Nilai == "Penambahan")
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak + this.header.Nilai_PP;
            else if(this.header.Type_Nilai == "Pengurangan") 
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - this.header.Nilai_PP;
            else if(this.header.Type_Nilai == "Cut Off"){
                result = ( (100/100) - (this.header.Persentase_Cut_Off/100) ) * this.header.Nilai_Awal_Kontrak
                this.header.Nilai_Akhir_Kontrak = this.header.Nilai_Awal_Kontrak - result;
            }
           
            return result;
        },
        isSPODisabled() {
            if (this.header && this.header.DeviationTemp < 0) 
            {
                this.header.New_SPO = false; 
                return true; 
            }
            if (this.header && this.header.Amount <= 0) {
                return true;
            }
            return this.mode !== this.$FORM_MODE_CREATE && this.mode !== this.$FORM_MODE_EDIT;
        },
        isSPOCategoryDisabled() {
            if (this.header && this.header.Amount <= 0) {
                return true;
            }
            return (this.mode !== this.$FORM_MODE_CREATE && this.mode !== this.$FORM_MODE_EDIT) && this.header.New_SPO === false;
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        this.type = this.$route.query.type;
        if(this.type == this.$TypeMC.MC0)
            this.typeName = this.$TypeNameMC.MC0;
        else if(this.type == this.$TypeMC.MC_BETWEEN)
            this.typeName = this.$TypeNameMC.MC_BETWEEN;
        else if(this.type == this.$TypeMC.MC100)
            this.typeName = this.$TypeNameMC.MC100;
        else
            this.typeName = "";
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>
<style scoped>
/* Yellow background for mismatched fields */
::v-deep(.bg-yellow) {
   background-color: #fcf1b1 !important;
}
</style>